module.exports = __webpack_public_path__ + "media/images/flags/lk-f64da0a0b0bcf898c35e2ed23e0e90c4.svg";